/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react'
import { BaseCarousel } from './Carousel';
import "./Orders.css"

export default class Orders extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      ORDERS: []
    };
  }
  componentDidMount() {
    this.setState({
      ORDERS: this.props.ORDERS
    });
  }

  render() {

    const Orders = this.state.ORDERS;
    let orders = [];

    if (Orders.length) {
      if (Orders.length > 1) {
        orders.push(
          <div>
            <div className="Orders_mob_container">
              <div className="Orders_mob_header">Прибыл</div>
              <div className="Orders_mob_body">
                <div className="Orders_mob_left">
                  <div>Уч. год</div>
                  <div>Курс</div>
                  <div>Приказ</div>
                  <div>Спец.</div>
                  <div >Группа</div>
                  <div className="Ubyl_mob">Убыл</div>
                </div>
                <div><BaseCarousel order={Orders} /></div>
              </div>
            </div>
          </div>
        )
      }
      else {
        orders.push(<div>
          <div className="Orders_mob_container">
            <div className="Orders_mob_header">Прибыл</div>
            <div className="Orders_mob_body">
              <div className="Orders_mob_left">
                <div>Уч. год</div>
                <div>Курс</div>
                <div>Приказ</div>
                <div>Спец.</div>
                <div>Группа</div>
                <div className="Ubyl_mob">Убыл</div>
              </div>
              <div className="carusel_main">  
                <div><p>{Orders[0].years}</p> </div>
                <div><p>{Orders[0].id_rate}</p></div>
                <div><p>{Orders[0].pribil}</p></div>
                <div><p>{Orders[0].spec}</p></div>
                <div><p>{Orders[0].groups}</p></div>
                <div><p>{Orders[0].ubil}</p></div>
              </div>
            </div>
          </div>
        </div>)
      }



      return (
        <div>
          {orders}
        </div>
      );
    }

    else return null
  }
}
